import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'report-action-submit',
  template: `
    <button class="btn btn-primary" (click)="onAction.emit()" [disabled]="!selectedAction || disabled" [busyButton]="busy">Execute</button>
  `
})
export class ReportActionsSubmitComponent {
  @Input() public selectedAction: boolean;
  @Input() public disabled: boolean;
  @Input() public busy: boolean;
  @Output() public onAction: EventEmitter<void> = new EventEmitter<void>();
}